export const FETCH_MOBILE_USERS_REQUEST =
  'mobileUsers/FETCH_MOBILE_USERS_REQUEST'
export const FETCH_MOBILE_USERS_SUCCESS =
  'mobileUsers/FETCH_MOBILE_USERS_SUCCESS'
export const FETCH_MOBILE_USERS_FAILURE =
  'mobileUsers/FETCH_MOBILE_USERS_FAILURE'

export const DELETE_MOBILE_USER_REQUEST =
  'mobileUsers/DELETE_MOBILE_USER_REQUEST'
export const DELETE_MOBILE_USER_SUCCESS =
  'mobileUsers/DELETE_MOBILE_USER_SUCCESS'
export const DELETE_MOBILE_USER_FAILURE =
  'mobileUsers/DELETE_MOBILE_USER_FAILURE'

export const CREATE_MOBILE_USER_REQUEST =
  'mobileUsers/CREATE_MOBILE_USER_REQUEST'
export const CREATE_MOBILE_USER_SUCCESS =
  'mobileUsers/CREATE_MOBILE_USER_SUCCESS'
export const CREATE_MOBILE_USER_FAILURE =
  'mobileUsers/CREATE_MOBILE_USER_FAILURE'

export const UPDATE_MOBILE_USER_REQUEST =
  'mobileUsers/UPDATE_MOBILE_USER_REQUEST'
export const UPDATE_MOBILE_USER_SUCCESS =
  'mobileUsers/UPDATE_MOBILE_USER_SUCCESS'
export const UPDATE_MOBILE_USER_FAILURE =
  'mobileUsers/UPDATE_MOBILE_USER_FAILURE'

export const FETCH_MOBILE_USER_REQUEST = 'mobileUsers/FETCH_MOBILE_USER_REQUEST'
export const FETCH_MOBILE_USER_SUCCESS = 'mobileUsers/FETCH_MOBILE_USER_SUCCESS'
export const FETCH_MOBILE_USER_FAILURE = 'mobileUsers/FETCH_MOBILE_USER_FAILURE'

export const REISSUE_ACTIVATION_CODE_REQUEST =
  'mobileUsers/REISSUE_ACTIVATION_CODE_REQUEST'
export const REISSUE_ACTIVATION_CODE_SUCCESS =
  'mobileUsers/REISSUE_ACTIVATION_CODE_SUCCESS'
export const REISSUE_ACTIVATION_CODE_FAILURE =
  'mobileUsers/REISSUE_ACTIVATION_CODE_FAILURE'

export const UPDATE_FIELD = 'mobileUsers/UPDATE_FIELD'
export const SET_DEFAULT_DATA = 'mobileUsers/SET_DEFAULT_DATA'
